<div>
  <button mat-icon-button [hidden]="showMenu" (click)="showMenuClick()">
    <app-icon name="more_horiz" [size]="20"></app-icon>
  </button>

  <div class="floating" [hidden]="!showMenu" (mouseleave)="hideMenuClick()">
    <div class="flex flex-row items-center justify-start gap-12">
      <ng-container *ngIf="showAddToCart">
        <button [appApiCallLoading]="initPayment" [disabled]="disabled" mat-icon-button matTooltip="Dodaj do koszyka">
          <app-icon name="add_shopping_cart" [color]="'white'" [size]="20"></app-icon>
        </button>
      </ng-container>

      <button
        *ngIf="showRedirectToCart"
        mat-icon-button
        matTooltip="Przejdź do koszyka"
        [routerLink]="['/liabilities', 'pay', liability.uncompletedPaymentId]"
        [disabled]="disabled"
      >
        <app-icon name="shopping_cart" [color]="'white'" [size]="20"></app-icon>
      </button>

      <ng-container *ngIf="showEdit">
        <button [appApiCallLoading]="edit" mat-icon-button matTooltip="Edytuj wydatek">
          <app-icon name="edit" [color]="'white'" [size]="20"></app-icon>
        </button>
      </ng-container>

      <ng-container *ngIf="showMarkAsPaid">
        <button
          [appApiCallLoading]="markAsPaid"
          [disabled]="
            (loadingService.watch({
              action: loadingAction.MARK_AS_PAID,
              namespace: 'liability',
              id: liability.id
            }) | async) || disabled
          "
          mat-icon-button
          matTooltip="Oznacz jako rozliczony"
        >
          <app-icon name="done" [color]="'white'" [size]="20"></app-icon>
        </button>
      </ng-container>

      <ng-container *ngIf="showMarkAsNotPaid">
        <button
          [appApiCallLoading]="markAsNotPaid"
          [disabled]="
            (loadingService.watch({
              action: loadingAction.MARK_AS_NOT_PAID,
              namespace: 'liability',
              id: liability.id
            }) | async) || disabled
          "
          mat-icon-button
          matTooltip="Oznacz jako nierozliczony"
        >
          <app-icon name="money_off" [color]="'white'" [size]="20"></app-icon>
        </button>
      </ng-container>

      <button *ngIf="showRemove" [appApiCallLoading]="hide" [disabled]="disabled" mat-icon-button matTooltip="Usuń">
        <app-icon name="delete" [color]="'white'" [size]="20"></app-icon>
      </button>

      <ng-container *ngIf="showRemoveFromCart">
        <button [appApiCallLoading]="cancelPayment" [disabled]="disabled" mat-icon-button matTooltip="Usuń z koszyka">
          <app-icon name="remove_shopping_cart" [color]="'white'" [size]="20"></app-icon>
        </button>
      </ng-container>

      <button
        *ngIf="showEnableAutoPayment && this.appConfig.config.payment.autoPayment.enabled"
        [appApiCallLoading]="enableAutoPayment"
        [disabled]="disabled"
        mat-icon-button
        matTooltip="Ustaw autopłatność"
      >
        <app-icon name="alarm_on" [color]="'white'" [size]="20"></app-icon>
      </button>

      <button
        *ngIf="showCreateAutoPayment && this.appConfig.config.payment.autoPayment.enabled"
        [appApiCallLoading]="createAutoPayment"
        [disabled]="disabled"
        mat-icon-button
        matTooltip="Ustaw autopłatność"
      >
        <app-icon name="alarm_on" [color]="'white'" [size]="20"></app-icon>
      </button>

      <button
        *ngIf="showCancelAutoPayment"
        [appApiCallLoading]="disableAutoPayment"
        [disabled]="
          disabled ||
          (loadingService.watch({
            action: loadingAction.CANCEL_AUTO_PAYMENT,
            namespace: 'liability',
            id: liability.id
          }) | async)
        "
        mat-icon-button
        matTooltip="Anuluj autopłatność"
      >
        <app-icon name="alarm_off" [color]="'white'" [size]="20"></app-icon>
      </button>

      <button
        *ngIf="showDelegate"
        [appApiCallLoading]="delegateLiability"
        mat-icon-button
        matTooltip="Przekaż do opłacenia"
      >
        <app-icon name="forward" [color]="'white'" [size]="20"></app-icon>
      </button>

      <button
        *ngIf="showDeleteDelegation"
        [appApiCallLoading]="deleteLiabilityDelegation"
        mat-icon-button
        matTooltip="Wyłącz przekazywanie"
      >
        <app-icon name="clear" [color]="'white'" [size]="20"></app-icon>
      </button>

      <button
        *ngIf="canBeReminded"
        [appApiCallLoading]="remindAboutPayment"
        [disabled]="
          loadingService.watch({
            action: loadingAction.REMIND_ABOUT_DELEGATED_PAYMENT,
            namespace: 'liability',
            id: liability.id
          }) | async
        "
        mat-icon-button
        matTooltip="Wyślij przypomnienie"
      >
        <app-icon name="add_alert" [color]="'white'" [size]="20"></app-icon>
      </button>

      <button
        *ngIf="showXsellOffer"
        [appApiCallLoading]="redirectToXsellOffer"
        [disabled]="disabled"
        mat-icon-button
        matTooltip="Zacznij oszczędzać"
      >
        <app-icon name="monetization_on" [color]="'white'" [size]="20"></app-icon>
      </button>

      <button
        *ngIf="showDownloadPdf"
        [appApiCallLoading]="downloadPdf"
        [disabled]="disabled"
        mat-icon-button
        matTooltip="Pobierz dokument"
      >
        <app-icon name="save_alt" [color]="'white'" [size]="20"></app-icon>
      </button>

      <button
        *ngIf="showDetails"
        [routerLink]="['/liabilities', liability.id]"
        mat-icon-button
        matTooltip="Zobacz szczegóły"
      >
        <app-icon name="description" [color]="'white'" [size]="20"></app-icon>
      </button>
    </div>
  </div>
</div>

<a hidden #downloadPdfLink target="_blank"></a>
